<p-card styleClass="list-card">
  <div class="section-header">
    <div>
      <h3>Vivier — Tournées</h3>
      <p>
        {{ filteredTours.length }}/{{ tours.length }}
        tournée(s)
      </p>
    </div>
    <div class="header-actions">
      <p-button
        icon="pi pi-plus"
        pTooltip="Créer une affaire (prise d'appel)"
        tooltipPosition="left"
        (click)="createAffairClicked.emit()"
      ></p-button>
      <p-button
        icon="pi pi-file-import"
        [outlined]="true"
        pTooltip="Ajouter une affaire existante"
        tooltipPosition="left"
        (click)="addExistingAffairClicked.emit()"
      ></p-button>
      <p-button
        icon="pi pi-times-circle"
        severity="secondary"
        [outlined]="true"
        [disabled]="!canClearSelection"
        pTooltip="Effacer la sélection et la recherche"
        tooltipPosition="left"
        (click)="clearSelectionAndSearch.emit()"
      ></p-button>
    </div>
  </div>

  @if (runCompleted && run?.completedAt) {
    <div class="run-info">
      <i class="pi pi-clock"></i>
      <span>
        Dernière optimisation :
        {{ formatDate(run!.completedAt!.substring(0, 10)) }}
        ·
        {{ run?.techniciansCount ?? '-' }} technicien(s)
      </span>
    </div>
  }

  @if (launchError) {
    <p class="launch-error">{{ launchError }}</p>
  }

  @if (tours.length > 0) {
    <div class="search-bar">
      <span class="p-input-icon-left" style="width: 100%">
        <i class="pi pi-search"></i>
        <input
          type="text"
          pInputText
          [ngModel]="searchQuery"
          (ngModelChange)="searchQueryChange.emit($event)"
          placeholder="Rechercher (technicien, affaire, réf. ML…)"
          style="width: 100%"
        />
      </span>
      <button
        type="button"
        class="eros-filter-chip"
        [class.is-active]="erosOnly"
        (click)="erosOnlyChange.emit(!erosOnly)"
        pTooltip="N'afficher que les affaires source EROS"
        tooltipPosition="top"
        aria-label="Filtrer les affaires source EROS"
      >
        <i class="pi pi-bolt"></i>
        EROS
      </button>
      <select
        class="grouping-filter"
        [ngModel]="selectedGroupingName"
        (ngModelChange)="onGroupingChange($event)"
      >
        <option value="">
          @if (hiddenMapGroups.size > 0) {
            Groupes visibles ({{ hiddenMapGroups.size }} masqué{{
              hiddenMapGroups.size > 1 ? 's' : ''
            }})
          } @else {
            Tous les groupes
          }
        </option>
        @for (groupingName of groupingNames; track groupingName) {
          <option [value]="groupingName">{{ groupingName }}</option>
        }
      </select>
    </div>
    <div class="tour-list">
      @for (tour of filteredTours; track tour.tourKey) {
        <button
          type="button"
          class="tour-item"
          [class.selected]="selectedTour?.tourKey === tour.tourKey"
          (click)="tourSelected.emit(tour)"
        >
          <div class="tour-topline">
            <span class="tour-date">{{ formatDate(tour.date) }}</span>
            <span class="tour-tech">
              <i class="pi pi-user"></i>
              {{ tour.technicianName }}
            </span>
          </div>
          <div class="tour-meta">
            <span class="tour-pool-count">
              {{ tour.poolAffairIds.length }} affaire{{
                tour.poolAffairIds.length > 1 ? 's' : ''
              }}
              vivier
            </span>
            <div class="item-badges">
              @if (requiresDayShift(tour)) {
                <span
                  class="badge-day-shift"
                  pTooltip="Cette proposition déplace des interventions programmées sur un autre jour (autorisé par EROS)"
                  tooltipPosition="top"
                >
                  <i class="pi pi-calendar-plus"></i>
                  @if (dayShiftCount(tour) > 0) {
                    {{ dayShiftCount(tour) }}
                  }
                  chgt de jour
                </span>
              }
              @if (tour.stopsCount != null) {
                <span class="badge-slots">
                  {{ tour.stopsCount }} étape{{
                    tour.stopsCount! > 1 ? 's' : ''
                  }}
                </span>
              }
            </div>
          </div>
          @if (recalculatingTourKeys.has(tour.tourKey)) {
            <div class="recalc-indicator">
              <i class="pi pi-sync"></i>
              <span>Recalcul en cours…</span>
            </div>
          }
        </button>
      }
    </div>
  } @else if (!launchLoading) {
    <div class="empty-panel">
      <i class="pi pi-inbox"></i>
      @if (runCompleted) {
        <p>
          Aucune tournée proposée. Relancez l'optimisation si le vivier a été
          mis à jour.
        </p>
      } @else {
        <p>
          Lancez l'optimisation pour calculer les créneaux et tournées pour les
          affaires du vivier.
        </p>
      }
    </div>
  }

  @if (launchLoading) {
    <div class="loading-inline">
      <p-progressSpinner styleClass="w-2rem h-2rem"></p-progressSpinner>
      <span>Optimisation en cours...</span>
    </div>
  }
</p-card>
